import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { C as Constants, a as AppErrorMessage } from './AppFormField-e5fa211c.esm.js';
import { useFormikContext } from 'formik';
import { A as AppPicker, a as AppPickerItem } from './index-b3be2636.esm.js';
import { View } from 'react-native';

function AppFormPicker(_ref) {
  let {
    name,
    width,
    options,
    optionKey,
    optionLabel,
    PickerItemComponent = AppPickerItem,
    numberOfColumns,
    onChange = () => {},
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(View, {
    style: {
      paddingBottom: Constants.ERROR_OFFSET * 2
    }
  }, /*#__PURE__*/React__default.createElement(AppPicker, _extends({
    onBlur: () => setFieldTouched(name),
    placeholder: placeholder,
    width: width,
    PickerItemComponent: PickerItemComponent,
    onSelectItem: item => {
      setFieldValue(name, item);
      onChange(item);
    },
    options: options,
    optionLabel: optionLabel,
    optionKey: optionKey,
    numberOfColumns: numberOfColumns,
    selectedItem: values && values[name]
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormPicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormPicker",
  "props": {
    "PickerItemComponent": {
      "defaultValue": {
        "value": "AppPickerItem",
        "computed": true
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppFormPicker as A };
